import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const ShopifyCallbackPage = lazy(() => import("./ShopifyCallbackPage"));

const ShopifyNoSubscriptionPage = lazy(
  () => import("./ShopifyNoSubscriptionPage")
);

export type ShopifyPagesNavigationParams = {
  shopifyCallback: PageNavParams;
  shopifyNoSubscription: PageNavParams;
};

export const shopifyPagesNavigationConfig: ModulePagesConfig<ShopifyPagesNavigationParams> =
  {
    // Configured as the app/redirect URL in the Shopify Partner dashboard.
    // isPrivate so that logged-out users bounce through /login?next=... and
    // come back with the callback query params intact
    shopifyCallback: {
      element: <ShopifyCallbackPage />,
      path: "/shopify/callback",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
      isActiveSubscriptionOptional: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
    shopifyNoSubscription: {
      element: <ShopifyNoSubscriptionPage />,
      path: "shopify-no-subscription",
      isPrivate: true,
      isActiveSubscriptionOptional: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
  };
